import { IStatusConfig } from '../../../components/StatusBadge'
import { ITabDef } from '../../../helpers/tabErrorUtils'
import {
  ContractType,
  JobRequisitionHistoryEvent,
  JobRequisitionStatus,
  WeekDay,
  WeekendMode
} from '../../../services/JobRequisition/types'

/** Status of a job requisition. Local on purpose: a set that belongs to this screen only. */
export const JOB_REQUISITION_STATUS: Record<JobRequisitionStatus, IStatusConfig> = {
  pending_validation: { label: 'Validação Pendente', colorScheme: 'yellow' },
  open: { label: 'Em Aberto', colorScheme: 'green' },
  rejected: { label: 'Reprovada', colorScheme: 'red' },
  cancelled: { label: 'Cancelada', colorScheme: 'gray' },
  completed: { label: 'Concluída', colorScheme: 'blue' }
}

/** The listing opens on the RPs still in progress. */
export const DEFAULT_STATUS_FILTER: JobRequisitionStatus[] = ['pending_validation', 'open']

export const CONTRACT_TYPE_LABELS: Record<ContractType, string> = {
  clt: 'CLT',
  pj: 'PJ'
}

export const CONTRACT_TYPE_OPTIONS = (Object.keys(CONTRACT_TYPE_LABELS) as ContractType[]).map((type) => ({
  value: type,
  label: CONTRACT_TYPE_LABELS[type]
}))

export const WEEK_DAYS: { value: WeekDay; label: string }[] = [
  { value: 'monday', label: 'Segunda-feira' },
  { value: 'tuesday', label: 'Terça-feira' },
  { value: 'wednesday', label: 'Quarta-feira' },
  { value: 'thursday', label: 'Quinta-feira' },
  { value: 'friday', label: 'Sexta-feira' },
  { value: 'saturday', label: 'Sábado' },
  { value: 'sunday', label: 'Domingo' }
]

export const WEEKEND_DAYS: WeekDay[] = ['saturday', 'sunday']

export const WEEKEND_MODE_LABELS: Record<WeekendMode, string> = {
  fixed: 'Fixo',
  alternate: 'Intercalado'
}

export const HISTORY_EVENT_LABELS: Record<JobRequisitionHistoryEvent['event'], string> = {
  created: 'Criada',
  signed: 'Assinada',
  rejected: 'Reprovada',
  closed: 'Fechada',
  cancelled: 'Cancelada'
}

// Same limit as the API (JobRequisitionStore::REASON_MAX_LENGTH).
export const REASON_MAX_LENGTH = 2000

export const JOB_REQUISITION_TAB_DEFS: ITabDef[] = [
  { key: 'mp', label: 'MP e cargo', fields: ['personnel_movement_request_id', 'manager_user_id'] },
  { key: 'descriptive', label: 'Descritivo', fields: ['duties', 'education', 'experience', 'skills'] },
  { key: 'schedule', label: 'Jornada e salário', fields: ['contract_type', 'salary', 'schedule'] },
  { key: 'site', label: 'Site e assinatura', fields: ['areas', 'allow_portfolio_link', 'signer_user_id'] }
]
